import { RealEstateCardController as RealEstateCard } from './realEstateCardController/realEstateCard.controller';

export default RealEstateCard;
